// 后端页面
// gen
const baseUrl = "http://xxx.com/admin";
// dev
// const baseUrl = "http://ys.liuyunchuan.com/admin";

export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js